import WithRender from "../../templates/base/productName.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getWebProductName"])
  }
});
